import React, { useEffect, useState } from 'react'
import { useInstantSearch } from 'react-instantsearch-hooks-web'
import { Button, Input } from '../../ui'
import { emailRegex } from '../../../constants'
import { sendResearchSubscriptionEmail } from './requests'

interface ResearchSubscriptionButtonProps {
  fromPage: 'offers' | 'firms'
  strapiUrl: string
  isResearchSubscriptionButtonActive: boolean
}

const ResearchSubscriptionButton: React.FC<ResearchSubscriptionButtonProps> = ({
  fromPage,
  strapiUrl,
  isResearchSubscriptionButtonActive,
}) => {
  const [isResearchSubscriptionModalOpen, setIsResearchSubscriptionModalOpen] =
    useState(false)
  const [email, setEmail] = useState<undefined | string>(undefined)
  const [errorEmail, setErrorEmail] = useState<undefined | string>(undefined)
  const [isSuccess, setIsSuccess] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const { indexUiState } = useInstantSearch()
  const {
    refinementList,
    query,
    configure: { aroundLatLng, aroundRadius, explain },
  } = indexUiState

  useEffect(() => {
    if (!email || email.length < 1 || !emailRegex.test(email)) {
      setErrorEmail('Veuillez entrer une adresse e-mail valide.')
    } else {
      setErrorEmail(undefined)
    }
  }, [email])

  async function handleSubmit() {
    setIsSubmitting(true)
    if (email) {
      const response = await sendResearchSubscriptionEmail({
        email,
        searchOn: fromPage,
        searchField: query,
        contractType: refinementList?.contractType,
        educationRequirement: refinementList?.educationRequirement,
        experienceRequirement: refinementList?.experienceRequirement,
        jobType: refinementList?.jobType,
        tools: refinementList?.tools,
        aroundLatLng,
        aroundRadius,
        explain: explain && explain.length > 0 ? explain[0] : undefined,
        strapiUrl,
      })
      if (response.id) {
        setIsSuccess(true)
      }
    }
    setIsResearchSubscriptionModalOpen(false)
    setIsSuccess(false)
    setIsSubmitting(false)
  }

  return (
    <>
      <div
        className={`fixed bg-gray-200/60 inset-0 z-10 ${
          isResearchSubscriptionModalOpen ? 'visible' : 'hidden'
        }`}
      >
        <div className="flex items-center justify-center h-full px-8 pb-5 overflow-y-auto text-gray-800 rounded-lg">
          <div
            className={`sticky top-0 z-10 flex flex-col px-4 pt-4 pb-2 space-y-4 bg-white rounded-md md:w-1/3 border-green-500 ${
              isSuccess ? 'border' : ''
            }`}
          >
            <div className="flex items-center justify-between space-x-6 border-b border-gray-300">
              <p className="font-semibold">S&apos;abonner aux résultats</p>
              <button
                type="button"
                className="text-sm text-gray-600 hover:underline focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
                onClick={() => setIsResearchSubscriptionModalOpen(false)}
              >
                fermer
              </button>
            </div>
            {isSuccess ? (
              <div>
                <p className="text-sm text-center text-gray-600">
                  Merci pour votre abonnement. Vous recevrez un email dès
                  qu&apos;une nouvelle offre correspondant à vos critères sera
                  publiée.
                </p>
              </div>
            ) : (
              <div className="space-y-2 md:space-y-4">
                <div className="text-sm font-medium">
                  Email *
                  <Input
                    label="email"
                    name="email"
                    form
                    icon="emailAddress"
                    type="email"
                    autoComplete="email"
                    value={email}
                    placeholder="prenom.nom@email.com"
                    disabled={isSubmitting}
                    onChange={(val) => setEmail(val)}
                  />
                </div>
                {errorEmail && (
                  <div className="mt-2 text-xs text-red-400">{errorEmail}</div>
                )}
                <div className="flex justify-center">
                  <Button
                    label="Souscrire"
                    size="medium"
                    color="primary"
                    invert
                    disabled={errorEmail !== undefined || isSubmitting}
                    onClick={() => handleSubmit()}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {(refinementList ||
        query ||
        aroundLatLng ||
        aroundRadius ||
        explain.length > 0) &&
        isResearchSubscriptionButtonActive && (
          <Button
            invert
            color="secondary"
            label="S'abonner à la recherche"
            disabled={isSubmitting}
            onClick={() => setIsResearchSubscriptionModalOpen(true)}
          />
        )}
    </>
  )
}

export default ResearchSubscriptionButton
